import { render, staticRenderFns } from "./ReCellByAddr.vue?vue&type=template&id=18cc8808&scoped=true"
import script from "./ReCellByAddr.vue?vue&type=script&lang=js"
export * from "./ReCellByAddr.vue?vue&type=script&lang=js"
import style0 from "./ReCellByAddr.vue?vue&type=style&index=0&id=18cc8808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc8808",
  null
  
)

export default component.exports